import { ADMIN_ROLES } from '@avanta/shared/constants/admins';
import { useFetchEnterpriseAdminsCount } from 'hooks/useFetchEnterpriseAdminsCount';

export const useAdministratorsSummary = (): {
  stats: { total: number; admin: number; manager: number; billing: number };
  isLoading: boolean;
} => {
  const totalQuery = useFetchEnterpriseAdminsCount();
  const adminQuery = useFetchEnterpriseAdminsCount(ADMIN_ROLES.ADMIN);
  const managerQuery = useFetchEnterpriseAdminsCount(ADMIN_ROLES.MANAGER);
  const billingQuery = useFetchEnterpriseAdminsCount(ADMIN_ROLES.BILLING);

  return {
    stats: {
      total: totalQuery.data ?? 0,
      admin: adminQuery.data ?? 0,
      manager: managerQuery.data ?? 0,
      billing: billingQuery.data ?? 0,
    },
    isLoading:
      totalQuery.isLoading ||
      adminQuery.isLoading ||
      managerQuery.isLoading ||
      billingQuery.isLoading,
  };
};
